/**
 * Cover/thumbnail that lazy-loads like a CSS background without changing layout.
 */
import React from "react";
import PropTypes from "prop-types";

import { VImage } from "form";

/**
 * Fills its box with `object-cover` and only fetches when near the viewport.
 *
 * @param {{ src?: string, error?: ""|"user"|"course", className?: string, eager?: boolean }} props
 */
const BThumb = ({ src, error, className, eager }) => (
  <div className={`overflow-hidden relative bg-gray-200 dark:bg-gray-700 ${className || ""}`}>
    {src ? (
      <VImage
        src={src}
        error={error}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
      />
    ) : null}
  </div>
);

BThumb.defaultProps = {
  src: "",
  error: "course",
  className: "",
  eager: false,
};

BThumb.propTypes = {
  src: PropTypes.string,
  error: PropTypes.oneOf(["", "user", "course"]),
  className: PropTypes.string,
  eager: PropTypes.bool,
};

export default BThumb;
